import axios from "axios";

export const GET_ALL_COMPANY = "GET_ALL_COMPANY";
export const GET_ONE_COMPANY = "GET_ONE_COMPANY";
export const MODIF_COMPANY = "MODIF_COMPANY";

export const getAllCompanies =
  (async_ = false) =>
  (dispatch) => {
    try {
      return async_
        ? axios.get("/companies")
        : axios.get("/companies").then((cli) => {
            dispatch({ type: GET_ALL_COMPANY, payload: cli.data.data });
          });
    } catch (error) {
      console.log("ERREUR GET ALL COMPANY ", error);
    }
  };

export const getOneCompany = (company) => (dispatch) => {
  try {
    return axios
      .get(`/companies/${company.documentId}?populate[logo][populate][file]=true`)

      .then((rep) => {
        dispatch({ type: GET_ONE_COMPANY, payload: rep.data.data });
      });
  } catch (error) {
    console.log("ERREUR ", error);
  }
};

export const getOneCompany_ = (id) => {
  try {
    return axios.get(`/companies/${id}`);
    /*
                    .then(rep => {
                        dispatch({ type: GET_ONE_COMPANY, payload: rep.data });
                    });
        */
  } catch (error) {
    console.log("ERREUR ", error);
  }
};

export const updateCompany = (companyState) => (dispatch) => {
  try {
      const documentId = companyState.documentId;
      delete companyState.documentId;

      return axios.put(`/companies/${documentId}`, {data : companyState})
                  .then(cli => {
                      dispatch({ type: MODIF_COMPANY, payload: cli.data })
                  });
  } catch (error) {
      console.log("ERREUR MODIFICATION COMPANY ", error);
  }
};